<template>
    <div class="holdRuleGroup">
        <page-title :title="pageTitle" icon="pe-7s-flag"/>

        <b-row v-if="$route.name !== 'holdRuleGroupEdit'" class="mb-4">
            <b-col cols="12" md="6">
                <b-card>
                    <b-card-title>Groepsinformatie</b-card-title>

                    <font-awesome-icon v-if="groupDataLoading" icon="spinner" spin class="mb-5"/>
                    <b-table-simple v-else small>
                        <b-tbody>
                            <b-tr>
                                <b-th>Naam</b-th>
                                <b-td>{{ localState.groupData.display_name }}</b-td>
                            </b-tr>

                            <b-tr>
                                <b-th>Aangemaakt</b-th>
                                <b-td>{{ localState.groupData.created_at | datetime }}</b-td>
                            </b-tr>

                            <b-tr
                                v-if="
                  localState.groupData.created_at !==
                  localState.groupData.updated_at
                "
                            >
                                <b-th>Bijgewerkt</b-th>
                                <b-td>{{ localState.groupData.updated_at | datetime }}</b-td>
                            </b-tr>

                            <b-tr>
                                <b-th>Status</b-th>
                                <b-td>
                  <span
                      v-if="localState.groupData.is_active"
                      class="badge badge-success"
                  >
                    Actief
                  </span>
                                    <span v-else class="badge badge-danger">Inactief</span>
                                </b-td>
                            </b-tr>

                            <b-tr>
                                <b-th>Orderdata wijziging benodigd</b-th>
                                <b-td>
                                    <span v-if="!localState.groupData.is_approvable">Ja</span>
                                    <span v-else>Nee</span>
                                </b-td>
                            </b-tr>

                            <b-tr>
                                <b-th>Is definitief</b-th>
                                <b-td>
                                    <span v-if="localState.groupData.is_status_hold_final">Ja</span>
                                    <span v-else>Nee</span>
                                </b-td>
                            </b-tr>

                            <b-tr v-if="hasIgnoredProducts">
                                <b-th>Uitgesloten producten</b-th>
                                <b-td>{{ ignoredProductIdenfiers }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-card>
            </b-col>
        </b-row>

        <font-awesome-icon v-if="groupDataLoading" icon="spinner" spin/>
        <b-row v-else>
            <b-col cols="12">
                <router-view
                    :groupData="localState.groupData"
                    @refresh="refreshHandler"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12">
                <b-button
                    @click="backButtonHandler"
                    class="bg-midnight-bloom text-white"
                >
                    Terug naar overzicht
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<style lang="scss">
.holdRuleGroup {
    margin-bottom: 1.5rem;

    .btn-group {
        gap: 0.5rem;
    }

    .btn {
        &:disabled {
            cursor: not-allowed;
        }
    }
}

.rule-info {
    gap: 0.5rem;
    border-bottom: 1px solid #ccc;
    padding-bottom: 2rem;
    margin-bottom: 2rem;
}
</style>

<script>
import _ from "lodash";
import PageTitle from "@/components/PageTitle.vue";
import GroupRules from "./components/GroupRules.vue";

export default {
    name: "Group",

    props: {
        groupIdentifier: {
            type: String,
            required: true,
        },
    },

    components: {
        PageTitle,
        GroupRules,
    },

    data() {
        return {
            groupDataLoading: true,
            groupData: {}, // This won't mutate on user changes, so we can use it as a reference to the data in localState
            localState: {
                // Local state is compared to the original data from the back-end to check if the user has made changes.
                groupData: [],
            },
        };
    },

    methods: {
        fetchGroupData() {
            this.groupDataLoading = true
            const apiPath = `/api/rest/hold-rule-groups/${this.groupIdentifier}`;

            this.$http
                .get(apiPath, {
                    params: {
                        include: "hold_rules",
                    },
                })
                .then((response) => {
                    this.groupData = response.data;
                    this.localState.groupData = _.cloneDeep(this.groupData);
                    this.groupDataLoading = false;
                })
                .catch((e) => {
                    this.$alert(
                        "Er is iets misgegaan bij het opvragen van de Hold Rule Groups",
                        "danger",
                        true
                    );
                    console.log(e);
                })
                .then(() => {
                    this.groupDataLoading = false;
                });
        },

        refreshHandler() {
            this.fetchGroupData();
        },

        backButtonHandler() {
            this.$router.push({name: "holdRuleGroups"});
        },
    },

    computed: {
        /**
         * Returns the page title
         * @returns {string} Page title
         */
        pageTitle() {
            return "Hold Rule Groep wijzigen"
        },

        hasIgnoredProducts() {
            return (
                _.get(
                    this.localState,
                    "groupData.additional_parameters.product_identifiers_to_ignore",
                    0
                ).length > 0
            );
        },

        ignoredProductIdenfiers() {
            const ignoredProductIdenfiers =
                this.localState.groupData.additional_parameters
                    .product_identifiers_to_ignore || [];
            return ignoredProductIdenfiers.join(", ").trim();
        },
    },

    created() {
        this.fetchGroupData();
    },
};
</script>
